import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const LIST: AppRouteRecordRaw = {
  path: '/platform', // 系统
  name: 'platform',
  permission: 'platform',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.platform',
    requiresAuth: true,
    icon: 'icon-apps',
    order: 8,
    permission: 'platform',
  },
  children: [
    {
      path: 'qrcodeManage', // The midline path complies with SEO specifications
      name: 'qrcodeManage',
      permission: 'platform:qrcode',
      component: () => import('@/views/system/service/index.vue'),
      meta: {
        locale: 'menu.qrcodeManage',
        requiresAuth: true,
        roles: ['*'],
        permission: 'platform:qrcode',
      },
    },
    {
      path: 'statisticsManage', // The midline path complies with SEO specifications
      name: 'statisticsManage',
      permission: 'platform:statistics',
      component: () => import('@/views/system/statistics/index.vue'),
      meta: {
        locale: 'menu.statisticsManage',
        requiresAuth: true,
        roles: ['*'],
        permission: 'platform:statistics',
      },
    },
  ],
};

export default LIST;
